import { Box } from '@mui/material'
import styled from '@mui/system/styled'

export const PreviewWrapper = styled(Box)({
  position: 'relative',
  height: '100%'
})

export const PreviewContent = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: 10,
  position: 'sticky',
  top: 16,
  height: '100%'
})
